module.exports = __webpack_public_path__ + "img/LogoYT.9ddb1783.png";